export default {
    title: 'Ausländische Partner:',
    showListing: 'Details anzeigen',
    hideListing: 'Details ausblenden',
    addPartner: 'Partner hinzufügen',
    addPartnerGroup: 'Partnergruppe hinzufügen',
    listing: {
        name: 'Name',
        name_identifier: 'Ausländischer Partner Name',
        placeholderName: 'Name der Organisation',
        phoneNumber: 'Telefon',
        phoneNumber_identifier: 'Ausländischer Partner Telefonnummer',
        email: 'E-Mail',
        email_identifier: 'Ausländischer Partner E-Mail',
        contactPerson: 'Ansprechpartner*in für inhaltliche Fragen',
        contactPerson_identifier: 'Ausländischer Partner Ansprechpartner*in',
        placeholderContactPerson: 'Vorname, Nachname',
        location: 'Adresse',
        location_identifier: 'Ausländischer Partner Adresse',
        placeholderLocation: 'Adresse oder Ort',
        partnerSince: 'Partner seit',
        partnerSince_identifier: 'Ausländischer Partner seit',
        placeholderPartnerSince: 'Jahr',
        group: {
            title: 'Partnergruppe',
            country: 'Land',
            participants_8_13: 'Teilnehmende 8-13 Jahre',
            participants_14_26: 'Teilnehmende 14-26 Jahre',
            participants_26plus: 'Sonstige über 26 Jahre (nicht gefördert)',
            reason_for_participants_26plus: 'Begründung',
            leaders_26plus: 'Leitende über 26 Jahre (gefördert)',
            reason_for_leaders_26plus: 'Begründung',
            total: 'Gruppengröße',
            others: 'Sonstige (nicht gefördert)',
            savePartnerGroup: 'Partnergruppe speichern'
        }
    }
}